exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".productScore[data-v-24e2766f] ::v-deepel-rate{line-height:2.4}.pictrue[data-v-24e2766f]{width:60px;height:60px;border:1px dotted rgba(0,0,0,.1);margin-right:10px;position:relative;cursor:pointer}.pictrue img[data-v-24e2766f]{width:100%;height:100%}.btndel[data-v-24e2766f]{position:absolute;z-index:1;width:20px !important;height:20px !important;left:46px;top:-4px}", ""]);

// exports
